(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["girlsgirl-community-carousel"] && !Shopify.designMode) return;
  try {
    
  const initializeEventCarousels = (scope = document) => {
    scope.querySelectorAll('[data-event-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';

      const track = carousel.querySelector('.gg-event-carousel__track');
      const slides = [...carousel.querySelectorAll('[data-event-slide]')];
      const previous = carousel.querySelector('[data-event-previous]');
      const next = carousel.querySelector('[data-event-next]');
      const counter = carousel.querySelector('[data-event-counter]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const desktopLayout = window.matchMedia('(min-width: 750px)');
      let activeIndex = 0;
      let carouselVisible = false;

      const formatNumber = (number) => String(number).padStart(2, '0');

      const loadVideo = (video) => {
        const source = video?.querySelector('source[data-src]');
        if (!source) return;
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        video.load();
      };

      const syncVideos = () => {
        slides.forEach((slide, index) => {
          const video = slide.querySelector('.gg-event-carousel__video');
          if (!video) return;

          if (index === activeIndex && carouselVisible) {
            loadVideo(video);
            if (!reduceMotion) video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      };

      const applyActiveState = () => {
        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          if (isActive) {
            slide.setAttribute('aria-current', 'true');
          } else {
            slide.removeAttribute('aria-current');
          }
        });

        if (counter) counter.textContent = `${formatNumber(activeIndex + 1)} / ${formatNumber(slides.length)}`;
        syncVideos();
      };

      const updateActiveSlide = () => {
        if (desktopLayout.matches) {
          applyActiveState();
          return;
        }

        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let closestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const distance = Math.abs(slideCenter - trackCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        applyActiveState();
      };

      const showSlide = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        applyActiveState();

        if (desktopLayout.matches) return;

        slides[activeIndex]?.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      };

      previous?.addEventListener('click', () => showSlide(activeIndex - 1));
      next?.addEventListener('click', () => showSlide(activeIndex + 1));
      track.addEventListener('scroll', updateActiveSlide, { passive: true });

      slides.forEach((slide, index) => {
        const card = slide.querySelector('.gg-event-carousel__card');
        card?.addEventListener('click', (event) => {
          if (!desktopLayout.matches || index === activeIndex) return;
          event.preventDefault();
          showSlide(index);
        });
      });

      const visibilityObserver = new IntersectionObserver(
        (entries) => {
          carouselVisible = entries.some((entry) => entry.isIntersecting);
          syncVideos();
        },
        { threshold: 0.1 }
      );

      visibilityObserver.observe(carousel);
      desktopLayout.addEventListener('change', () => {
        if (desktopLayout.matches) track.scrollLeft = 0;
        showSlide(activeIndex);
      });
      applyActiveState();
    });
  };

  initializeEventCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeEventCarousels(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["girlsgirl-community-video"] && !Shopify.designMode) return;
  try {
    
  const initializeCommunityVideos = (scope = document) => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    scope.querySelectorAll('.gg-community__video').forEach((video) => {
      if (video.dataset.videoInitialized === 'true' || reduceMotion) return;
      video.dataset.videoInitialized = 'true';

      const loadAndPlay = () => {
        const source = video.querySelector('source[data-src]');
        if (source) {
          source.src = source.dataset.src;
          source.removeAttribute('data-src');
          video.load();
        }
        video.play().catch(() => {});
      };

      if (!('IntersectionObserver' in window)) {
        loadAndPlay();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          loadAndPlay();
        },
        { rootMargin: '300px 0px' }
      );

      observer.observe(video);
    });
  };

  initializeCommunityVideos();
  document.addEventListener('shopify:section:load', (event) => initializeCommunityVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["girlsgirl-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeGirlsgirlVideoHero = (hero) => {
    if (hero.dataset.videoInitialized === 'true') return;
    const video = hero.querySelector('video');
    if (!video) return;

    hero.dataset.videoInitialized = 'true';

    const revealVideo = () => {
      hero.classList.add('is-video-ready');
      video.muted = true;
      video.loop = true;
      video.play().catch(() => {});
    };

    video.addEventListener('loadeddata', revealVideo, { once: true });
    video.addEventListener('pause', () => {
      if (document.visibilityState === 'visible') video.play().catch(() => {});
    });
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') video.play().catch(() => {});
    });

    if (video.readyState >= 2) revealVideo();
  };

  const initializeGirlsgirlVideoHeroes = (scope = document) => {
    scope.querySelectorAll('[data-gg-video-hero]').forEach(initializeGirlsgirlVideoHero);
  };

  initializeGirlsgirlVideoHeroes();
  document.addEventListener('shopify:section:load', (event) => initializeGirlsgirlVideoHeroes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
